import listReducer from './list/reducer';

export default {
  dataList: listReducer,
};
